import { getLocale } from "../runtime";

const sv_itcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Italien`
};

const itcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_itcountry(inputs)
	return "itCountry";
};

export { itcountry as "itCountry" };